import { render, staticRenderFns } from "./VAutocompletePublic.vue?vue&type=template&id=53d55e80"
import script from "./VAutocompletePublic.vue?vue&type=script&lang=js"
export * from "./VAutocompletePublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports